import TitleBlock from '@anm/components/TitleBlock';
import Button from '@anm/components/buttons/Button';
import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import styled from 'styled-components';

export const TitleBlockWrapper = styled(TitleBlock)`
  margin-bottom: 24px;
`;

export const P = styled.p`
  font-size: 16px;
  line-height: 25px;
`;

export const SupportButton = styled(Button)`
  padding: 0px;
  height: auto;
  min-width: auto;
  vertical-align: middle;
`;

export const ButtonWrapper = styled(ButtonLoader)`
  padding: 10px;
`;

export const FlexRight = styled.div`
  display: flex;
  justify-content: right;
  flex: auto;
`;

export const Container = styled.div`
  padding: 16px;
  margin-bottom: 8px;

  background: #fff4db;
  border: 1px solid #fcbd26;
  border-radius: 10px;
  font-size: 14px;
  line-height: 22px;
  color: #292a2b;

  > ul {
    list-style: disc;
    > li {
      margin-left: 20px;
    }
  }
`;

export const InfoContainer = styled.div`
  padding: 16px;
  margin-bottom: 8px;

  background: #d9f2ff;
  border: 1px solid #30aef2;
  border-radius: 10px;
  font-size: 14px;
  line-height: 22px;
  color: #292a2b;

  > ul {
    list-style: disc;
    > li {
      margin-left: 20px;
    }
  }
`;

export const Bold = styled.span<{ size: string }>`
  font-weight: 700;
  size: ${({ size }) => `${size}px`};
`;

const Wrapper = styled.div``;

export default Wrapper;
